import React from 'react'
import { FaReact, FaNode, FaBootstrap } from "react-icons/fa";
import { SiExpress, SiTailwindcss, SiArduino } from "react-icons/si";
import { DiMongodb } from "react-icons/di";
import { GiCircuitry } from "react-icons/gi";

export default function Services({ ServiceRef }) {
  const services = [
    {
      icon: FaReact,
      title: "ReactJS",
      description: "Can manage state with React knowledge in hooks, Redux, npm"
    },
    {
      icon: FaNode,
      title: "NodeJS",
      description: "Experienced in building backend services with Node.js and Express"
    },
    {
      icon: SiExpress,
      title: "ExpressJS",
      description: "Proficient in developing RESTful APIs with Express.js"
    },
    {
      icon: DiMongodb,
      title: "MongoDB",
      description: "Skilled in using MongoDB for building scalable and high-performance databases"
    },
    {
      icon: SiTailwindcss,
      title: "TailwindCSS",
      description: "Expert in using Tailwind CSS for building responsive and modern web designs"
    },
    {
      icon: FaBootstrap,
      title: "Bootstrap",
      description: "Proficient in using Bootstrap for rapid UI development"
    },
    {
      icon: SiArduino,
      title: "Arduino",
      description: "Experienced in building IoT projects using Arduino"
    },
    {
      icon: GiCircuitry,
      title: "NodeMCU",
      description: "Knowledgeable in designing and implementing electronic circuits via internet"
    },
  ];

  return (
    <div ref={ServiceRef} className='relative flex flex-col min-h-screen justify-center z-10 bg-gradient-to-t from-[#000000] to-[#444444]'>
        <h1 className='text-3xl md:text-5xl font-bold self-center text-[#80ed99] text-center'>
            Services!
          </h1>
          <h1 className='font-sans text-[15px] md:text-[20px] self-center mt-[-20px] text-[#a7abdf]'>
            what i do?
          </h1>
      <div className='bg-image flex flex-wrap justify-center gap-6 p-14'>
        
        {services.map((service, index) => (
          <div key={index} className='group h-[150px] md:h-[250px] w-full sm:w-[40%] md:w-[30%] lg:w-[22%] border-[1px]  border-white text-white flex justify-center items-center shadow-black shadow-[inset_0_0_15px_15px_rgba(0,0,0,0.6)] relative rounded-3xl transform transition-transform duration-300 hover:scale-105 hover:border-black hover:ease-in hover:shadow-white hover:shadow-[0_0_15px_5px_rgba(255,255,255,0.6)]'>
            {React.createElement(service.icon, { className: "transition-transform duration-300 group-hover:blur-sm", size: "3em" })}
            <span className="absolute opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-3xl font-black self-start bg-black w-full rounded-t-3xl p-2 ">{service.title}</span>
            <span className="absolute opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-xl font-medium self-end text-white bg-black overflow-hidden rounded-b-3xl text-center p-2" style={{ textShadow: '0px 0px 5px #000 ' }}>{service.description}</span>
          
          </div>
        ))}
      </div>
    </div>
  )
}
